import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { filter, take } from 'rxjs/operators';
import { AuthService } from '../../auth/auth.service';
import { SelectAccountComponent } from '../components/modals/select-account/select-account.component';
import { CachingService } from './caching.service';
import { Employee } from '../models/employee';

@Injectable({ providedIn: 'root' })
export class MobileAccountPickerService {
  constructor(
    private readonly authService: AuthService,
    private readonly cachingService: CachingService,
    private readonly modalService: BsModalService
  ) {
    this.cachingService.employee$
      .pipe(filter((employee: Employee) => this.shouldHandle(employee)), take(1))
      .subscribe((employee: Employee) => {
        this.authService.hasFreshOAuthRedirect = false;

        if (employee.accounts?.length > 1) {
          this.modalService.show(SelectAccountComponent, {
            class: 'modal-right-end-full-height-add',
            ignoreBackdropClick: true
          });
        } else if (employee.accounts?.length === 1) {
          // Single account — update the cache so future restarts don't rely on claims
          this.cachingService.setCurrentAccount(employee.accounts[0]);
        }
      });
  }

  private shouldHandle(employee: Employee): boolean {
    return (
      Capacitor.getPlatform() !== 'web' &&
      this.authService.hasFreshOAuthRedirect &&
      !!employee
    );
  }
}
